import dynamic from 'next/dynamic';
import { useState } from 'react';
import { translate } from '@/core/localization/translate';
import { ThemedButton } from '@/domains/core/page/components/ThemedButton/ThemedButton.default';
import { Slide } from '@/productDiscovery/ProductPage/common/components/Carousel/components/Slide/Slide';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';
import styles from './GalleryWall.module.scss';
const {
  seeMore
} = translate({
  "seeMore": "See more photos"
});
const DynamicZoomModal = dynamic(() => import('@/productDiscovery/ProductPage/common/components/Carousel/components/ZoomModal/UncontrolledZoomModal').then(mod => mod.UncontrolledZoomModal), {
  ssr: false
});
export const GalleryWall = () => {
  const {
    media: medias,
    title
  } = useDetail();
  const [zoomModalIndex, setZoomModalIndex] = useState<number | null>(null);
  if (!medias) {
    return null;
  }
  if (medias.length === 1) {
    const {
      largeUrl,
      type
    } = medias[0];
    return <>
        <div role="button" className={styles.picture} onClick={() => setZoomModalIndex(0)} onKeyPress={() => setZoomModalIndex(0)} tabIndex={0}>
          <Slide mediaURL={largeUrl || ''} type={type} regularUrl={largeUrl || ''} zoomUrl={largeUrl || ''} alt={title || ''} loading="eager" fetchPriority="high" key={largeUrl} isVisible />
        </div>
        {zoomModalIndex !== null && <DynamicZoomModal onClose={() => setZoomModalIndex(null)} onChangeSlide={() => null} currentSlide={zoomModalIndex} />}
      </>;
  }
  return <div className={styles.root}>
      <div className={styles.container}>
        {medias.slice(0, 4).map((mediaItem, index) => <div role="button" className={styles.picture} onClick={() => setZoomModalIndex(index)} onKeyPress={() => setZoomModalIndex(index)} key={mediaItem.regularUrl} tabIndex={index}>
            <Slide mediaURL={mediaItem.regularUrl || ''} type={mediaItem.type} regularUrl={mediaItem.regularUrl || ''} zoomUrl={mediaItem.largeUrl || ''} alt={mediaItem.title || ''} loading="eager" fetchPriority="high" isVisible />
          </div>)}
        {zoomModalIndex !== null && <DynamicZoomModal onClose={() => setZoomModalIndex(null)} onChangeSlide={() => null} currentSlide={zoomModalIndex} />}
      </div>
      {medias.length > 4 && <div className={styles.more}>
          <ThemedButton className={styles.seeMoreButton} variant="secondary" onClick={() => setZoomModalIndex(4)}>
            {seeMore}
          </ThemedButton>
        </div>}
    </div>;
};